import { render, staticRenderFns } from "./MemberShop.vue?vue&type=template&id=1622a56f&scoped=true"
import script from "./MemberShop.vue?vue&type=script&lang=js"
export * from "./MemberShop.vue?vue&type=script&lang=js"
import style0 from "./MemberShop.vue?vue&type=style&index=0&id=1622a56f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1622a56f",
  null
  
)

export default component.exports